import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ContextService} from './context.service';
import {UserSOICampaignDonationModel} from '@app/models/user-soi-campaign-donation.model';
import {PiiValidateModel, PiiValidateReturnModel} from '@app/models/pii-validate.model';

@Injectable({
  providedIn: 'root',
})
export class UserSoiCampaignDonationService {
  constructor(private http: HttpClient, private contextService: ContextService) {
  }

  submitSOICampaignDonation(soiCampaignId: number, modelData: UserSOICampaignDonationModel): Observable<any> {
    return this.http.post<any>(`${this.contextService.contextObject.apiBaseUrlV1}/api/1.0/organizing/soi/campaign/${soiCampaignId}/tenant/${this.contextService.contextObject.tenantName}/submit`, modelData);
  }

  validatePii(dataModel: PiiValidateModel): Observable<PiiValidateReturnModel> {
    return this.http.post<PiiValidateReturnModel>(`${this.contextService.contextObject.apiBaseUrlV1}/api/1.0/organizing/soi/campaign/${this.contextService.contextObject.tenantName}/person/duplicatecheck`, dataModel);
  }





}
